import api from "../index"
import { apiTags } from "../tags"

const reportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDashboardReports: build.query({
      query: (params) => ({
        url: `/investor/reports/dashboard`,
        method: "GET",
        params,
      }),
    }),
    getBlog: build.query({
      query: ({ id }) => ({
        url: `/investor/reports/blog/${id}`,
        method: "GET",
      }),
    }),

    getPlaylist: build.query({
      query: ({ user_type }) => ({
        url: `/${user_type}/reports/videos`,
        method: "GET",
      }),
    }),
    getDocuments: build.query({
      query: ({ user_type }) => ({
        url: `/${user_type}/reports/documents`,
        method: "GET",
      }),
    }),
    getTdsCerificates: build.query({
      query: ({ type }) => ({
        url: `/investor/reports/tds/${type}`,
        method: "GET",
      }),
    }),

    getInvestmentSchedules: build.query({
      query: () => ({
        url: `/investor/reports/investment-schedule`,
        method: "GET",
      }),
    }),
    getDocSigningLink: build.query({
      query: (body) => ({
        url: `/investors/sign/link`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useLazyGetDashboardReportsQuery,
  useLazyGetBlogQuery,
  useLazyGetPlaylistQuery,
  useLazyGetDocumentsQuery,
  useLazyGetTdsCerificatesQuery,
  useLazyGetInvestmentSchedulesQuery,
  useLazyGetDocSigningLinkQuery,
} = reportsApi
